import {useEffect} from 'react';
import {inPageHashTarget} from './scroll-spy';
import {scrollToSection} from './section-nav';

/**
 * Global safety net for `<a href="#id">` (e.g. a table of contents inside a
 * custom page body). With `<base href="/">` the browser would resolve it to
 * `/#id` and leave the page. We scroll to the element instead and keep the
 * current URL (hash updated with replaceState).
 */
export function InPageAnchorGuard() {
  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
        return;
      }
      const anchor = (e.target as HTMLElement | null)?.closest?.('a');
      if (!anchor || anchor.target === '_blank') return;
      const id = inPageHashTarget(anchor.getAttribute('href'));
      if (id === null) return;
      e.preventDefault();
      if (scrollToSection(id)) {
        const url = `${window.location.pathname}${window.location.search}#${encodeURIComponent(id)}`;
        window.history.replaceState(window.history.state, '', url);
      }
    };
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, []);
  return null;
}
